import { z } from "zod";

export const duplicateBoardSchema = z.object({
  boardName: z.string().min(1, "Board name is required").max(255, "Board name must be less than 255 characters"),
  all: z.boolean(),
  template: z.boolean(),
  tasks: z.boolean(),
  resources: z.boolean(),
  clients: z.boolean(),
  users: z.boolean(),
  contacts: z.boolean()
}).refine(
  (data) => data.all || data.template || data.tasks || data.resources || data.clients || data.users || data.contacts,
  {
    message: "At least one duplication option must be selected",
    path: ["all"]
  }
);

export type DuplicateBoardFormData = z.infer<typeof duplicateBoardSchema>;
